import React from 'react';
import {
  styled,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import ChevronDownIcon from '@components/Icons/ChevronDown';

const AccordionStyled = styled(props => (
  <Accordion disableGutters square {...props} />
))(() => ({
  color: 'white',
  background: 'transparent',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummaryStyled = styled(props => (
  <AccordionSummary expandIcon={<ChevronDownIcon />} {...props} />
))(() => ({
  padding: 0,
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(180deg)',
  },
  '& .MuiAccordionSummary-content': {
    margin: '17px 0 12px 0',
  },
}));

const AccordionDetailsStyled = styled(AccordionDetails)(({ theme }) => ({
  padding: 0,
}));

export default function({
  data,
  defaultExpanded,
  styleRoot,
  styleAccordionDetails,
}) {
  const [expanded, setExpanded] = React.useState(defaultExpanded || '');
  const handleExpand = panel => (e, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return data.map(
    ({ id, title, subtitleChip, defaultExpanded, ComponentDetails }) => (
      <React.Fragment key={id}>
        <AccordionStyled
          key={id}
          defaultExpanded={defaultExpanded}
          expanded={expanded === id}
          onChange={handleExpand(id)}
          sx={{ ...styleRoot }}
        >
          <AccordionSummaryStyled
            aria-controls={`${id}d-content`}
            id={`${id}d-header`}
          >
            <Typography fontWeight="fontWeightBold">{title}</Typography>
            <Chip
              label={subtitleChip}
              sx={{
                ml: 1.625,
                my: 'auto',
                color: 'inherit',
                cursor: 'pointer',
              }}
            />
          </AccordionSummaryStyled>
          <AccordionDetailsStyled sx={{ ...styleAccordionDetails }}>
            {ComponentDetails}
          </AccordionDetailsStyled>
        </AccordionStyled>
        <Divider sx={{ my: 0.5 }} />
      </React.Fragment>
    ),
  );
}
